import React from 'react'
import {Card, CardHeader, Col, FormGroup, Input, Modal, Table,} from "reactstrap";
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import dateHelpers from "../../helpers/DateHelper";
import ErrorModal from "../Alerts/ErrorModal";
import businessApiService from "../../api/business-api-service";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import Select from "react-select";
import businessHelper from "../../helpers/BusinessHelper";
import InvoicesView from "./InvoicesView";
import InvoiceReportRow from "../reports/InvoiceReportRow";
import {student_strings} from "../../translations/student_translations";
import TeamMemberTableRow from "../Tables/TeamMemberTableRow";
import {MdReportProblem} from "react-icons/all";
import LocaleModal from "../Alerts/LocaleModal";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);
let studentStrings = new LocalizedStrings(student_strings);

const propTypes = {};

export default class TeamMembers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            input: {
                email: "",
                role: businessHelper.teamMemberTypes()[0]
            },
            isLoading: false,
            teamMembers: null,
            showInputs: false,
        };
    }

    deleteMember = this.deleteMember.bind(this);
    showLocales = this.showLocales.bind(this);
    toggleLocaleModal = this.toggleLocaleModal.bind(this);
    selectLocale = this.selectLocale.bind(this);

    componentDidMount() {
        this.getData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.period !== this.state.period) {
            this.handleValidation();
            this.setState({showSearchButton: true})
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-email":
                this.setState(prevState => ({
                    input: {
                        ...prevState.input,
                        email: newValue
                    }
                }));
            default:
                return null;
        }
    }

    toggleLocaleModal() {
        this.setState({showLocales: !this.state.showLocales})
    };

    selectLocale(e, locale) {
        e.preventDefault();
        const member = this.state.selectedMember;
        console.log(JSON.stringify(member))
        this.toggleLocaleModal()

        this.updateMember(member, locale)
    };

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showMessageModal === true &&
                    this.renderMessageModal()
                    }

                    {this.state.showInvoiceModal &&
                    this.renderInvoiceModal()
                    }

                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    {this.state.showLocales === true &&
                    <LocaleModal toggleModal={this.toggleLocaleModal} locales={businessHelper.businessLocales()}
                                 setLocale={this.selectLocale}/>
                    }

                    <Col lg="12">
                        <Card className="bg-default shadow">
                            <Row style={{marginLeft: 4}}>
                                {this.state.showInputs === true &&
                                <Col lg="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-email"
                                        >
                                            {commonStrings.email}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange.bind(this)}
                                            id="input-email"
                                            type="email"
                                        />
                                    </FormGroup>
                                </Col>
                                }
                                {this.state.showInputs === true &&
                                <Col lg="3">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-end"
                                        >
                                            {resourceStrings.role}
                                        </label>

                                        <Select
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                height: "calc(2.75rem + 2px)"
                                            }}
                                            placeholder={commonStrings.select}
                                            className="form-control-alternative"
                                            value={this.state.input.role}
                                            onChange={this.handleRoleSelected}
                                            options={businessHelper.teamMemberTypes()}
                                        />
                                    </FormGroup>
                                </Col>
                                }
                                <Col lg="auto" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <Row style={{marginTop: 4}}>
                                        {this.state.showInputs !== true &&
                                        <Col>
                                            <Button

                                                color={"warning"}
                                                onClick={this.showInputs.bind(this)}
                                                size="lg"
                                            >
                                                {resourceStrings.add_team_member}
                                            </Button>
                                        </Col>
                                        }
                                        {this.state.showInputs === true &&
                                        <Col>
                                            <Button
                                                color="white"
                                                outline={true}
                                                onClick={e => this.addMember(e)}
                                                size="lg"
                                            >
                                                {commonStrings.add}
                                            </Button>
                                        </Col>
                                        }
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <small style={{
                                    color: "white",
                                    margin: 32
                                }}>{resourceStrings.cabinet.team_management_expl} {resourceStrings.cabinet.add_teacher_expl} {resourceStrings.cabinet.add_admin_expl}</small>
                                <small style={{
                                    color: "white",
                                    marginLeft: 32,
                                    marginTop: 10
                                }}>{resourceStrings.cabinet.loc_admin_expl}</small>
                            </Row>

                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent">
                                    <Row>
                                        <h2 className="text-white mb-0">{resourceStrings.team_members}</h2>
                                    </Row>
                                </CardHeader>
                                {this.renderReport()}
                            </Card>
                        </Card>
                    </Col>
                </>
            </LoadingOverlay>
        )
    }

    showLocales(e, member) {
        if (e) e.preventDefault();
        this.setState({showLocales: true, selectedMember: member})
    }

    renderTable() {
        return this.state.teamMembers.map((member, index) => {
            return (
                <TeamMemberTableRow member={member} key={member.id} deleteMember={this.deleteMember.bind(this)}
                                    showLocales={this.showLocales}/>
            )
        })
    }

    renderReport() {
        if (this.state.teamMembers !== null) {
            return <Table
                className="align-items-center table-dark table-flush"
                responsive
            >
                <thead className="thead-dark">
                <tr>
                    <th scope="col">{commonStrings.name}</th>
                    <th scope="col">{resourceStrings.role}</th>
                    <th scope="col" className="text-center">{commonStrings.business.locale}</th>
                    <th scope="col"/>
                </tr>
                </thead>
                <tbody>
                {this.renderTable()}
                </tbody>
            </Table>;
        }
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getData() {
        this.setState({isLoading: true});

        businessApiService.getTeam()
            .then(res => {
                this.setState({
                    teamMembers: res.users,
                    serverMessage: res.message,
                    isLoading: false,
                });
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    deleteMember(member) {
        businessApiService.deleteMember({member_email: member.email})
            .then(res => {
                if (res.message) {
                    this.showMessage(res.message)
                } else {
                    this.setState({teamMembers: res.users})
                }
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    updateMember(member, locale) {
        this.setState({isLoading: true, teamMembers: []});

        businessApiService.updateMember(member, locale)
            .then(res => {
                if (res.message) {
                    this.showMessage(res.message)
                } else {
                    this.setState({teamMembers: res.users})
                }
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => {
                this.setState({isLoading: false})
            });
    }

    addMember(e) {
        e.preventDefault();

        const data = {member_email: this.state.input.email, member_role: this.state.input.role.value};

        businessApiService.addMember(data)
            .then(res => {
                if (res.message) {
                    this.showMessage(res.message)
                } else {
                    this.setState({
                        teamMembers: res.users,
                        showInputs: false,
                        input: {email: "", role: businessHelper.teamMemberTypes()[0]}
                    })
                }
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    showMessage(message) {
        if (message && message.length > 0) {
            let m;
            switch (message) {
                case "user_already_member":
                    m = alertStrings.user_already_member;
                    break;
                case "no_user_with_this_email":
                    m = alertStrings.no_user_with_this_email;
                    break;
                default:
                    break;
            }

            if (m.length > 0) this.setState({serverMessage: m, showMessageModal: true})
        }
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    showInputs() {
        this.setState({showInputs: true})
    }

    handleRoleSelected = selectedOption => {
        this.setState(prevState => ({
            input: {
                ...prevState.input,
                role: selectedOption
            }
        }));
    };

    toggleMessageModal = state => {
        this.setState({
            showMessageModal: !this.state.showMessageModal
        });
    };

    renderMessageModal() {
        return (<Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-danger"
            isOpen={this.state.showMessageModal}
            toggle={() => this.toggleMessageModal("notificationModal")}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleMessageModal("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <i style={{color: "white", fontSize: 50}} className="fas fa-mail-bulk"/>
                    <h4 className="heading mt-4">{alertStrings.message_from_open}</h4>
                    <p>
                        {this.state.serverMessage}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleMessageModal("notificationModal")}
                >
                    {commonStrings.close}
                </Button>
            </div>
        </Modal>)
    }

}

TeamMembers.propTypes = propTypes;